import React from 'react';
import { Separator } from '@/Components/shadcn/separator';
import { Label } from '@/Components/shadcn/label';
import UIStrings from '@/Utils/UIStrings';
import SkillsSelector from './SkillsSelector';
import AutocompleteOptionType from '@/Models/AutocompleteOptionType';

function RequiredSkills(): React.JSX.Element {
    return (
        <div className="flex flex-col gap-2.5">
            <Label>{UIStrings.SkillsRequiredToSucceed}</Label>
            <div className="border-border bg-card flex flex-col rounded-lg border">
                <SkillsSelector
                    type={AutocompleteOptionType.HardSkill}
                    label={UIStrings.HardSkills}
                    placeholder={UIStrings.AddSkills}
                    tooltip={UIStrings.ThisSectionIncludesTheSkillRequiredToSucceed('hard skills')}
                />
                <Separator className="border-border" />
                <SkillsSelector
                    type={AutocompleteOptionType.SoftSkill}
                    label={UIStrings.SoftSkillsPersonalityTraits}
                    placeholder={UIStrings.TypePersonalityTraits}
                    tooltip={UIStrings.ThisSectionIncludesTheSkillRequiredToSucceed(
                        'soft skills and personality traits',
                    )}
                />
            </div>
        </div>
    );
}

export default RequiredSkills;
